import React, { useState } from 'react';
import { MapView } from './map/MapView';
import { TabNavigation } from './TabNavigation';
import { InputsTab } from './inputs/InputsTab';
import { PredictionsTab } from './predictions/PredictionsTab';
import { COARecommendationsTab } from './recommendations/COARecommendationsTab';
type Tab = 'COP' | 'inputs' | 'predictions' | 'recommendations';
export const Dashboard = () => {
  const [activeTab, setActiveTab] = useState<Tab>('COP');
  return <main className="w-full min-h-screen bg-gray-50" data-id="element-1">
      <div className="max-w-[1440px] mx-auto p-6" data-id="element-2">
        <h1 className="text-2xl font-semibold text-gray-900 mb-6" data-id="element-3">
          PORTAL Dashboard
        </h1>
        <TabNavigation activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-4" />
        <div className="mt-6 bg-white rounded-lg shadow-sm" data-id="element-5">
          {activeTab === 'COP' && <MapView data-id="element-6" />}
          {activeTab === 'inputs' && <InputsTab data-id="element-7" />}
          {activeTab === 'predictions' && <PredictionsTab data-id="element-8" />}
          {activeTab === 'recommendations' && <COARecommendationsTab data-id="element-9" />}
        </div>
      </div>
    </main>;
};